import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'store/reducers';
import { ReceiptByIdResponse } from './receipt.model';
import { PostConfirmRefundResponse } from './receipts.model';

interface ReceiptState {
  refundAmount: string;
  refundReason: string;
  receiptData: ReceiptByIdResponse;
  refundData: PostConfirmRefundResponse;
}

const initialState: ReceiptState = {
  // TODO: additional tax: remove fields related to invoice level additional tax by replacing it with service charge
  refundAmount: '',
  refundReason: '',
  receiptData: {
    customer: {
      id: '',
      merchantId: '',
      teamID: 0,
      name: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      billingAddressId: 0,
      customerNumber: '',
      companyName: '',
      referenceNumber: '',
      note: '',
      isBillingSameAsService: false,
      createdBy: '',
      updatedBy: '',
      createdAt: '',
      updatedAt: '',
      billingAddress: null,
      serviceAddress: []
    },
    ID: '',
    teamId: 0,
    amount: '',
    paidAmount: '',
    invoicedAmount: '',
    tipAmount: '',
    surchargeAmount: '',
    serviceChargeAmount: '',
    billAmount: '',
    merchantName: '',
    merchantPhoneNumber: '',
    merchantAddress: '',
    storeName: '',
    displayName: '',
    successMessage: '',
    currency: '',
    currencySymbol: '',
    countryCode: '',
    date: '',
    time: '',
    transactionCreatedAt: '',
    paidAt: '',
    invoiceCreatedAt: '',
    paymentMethod: '',
    status: '',
    invoiceNumber: '',
    customerName: '',
    qrId: '',
    qr: '',
    merchantType: '',
    timestamp: '',
    slot: '',
    hours: 0,
    endTime: '',
    hasSurcharge: false,
    hasTip: false,
    websiteConfig: {
      enabled: false,
      websiteURL: ''
    },
    cardDetails: {
      cardLast4: '',
      funding: '',
      network: '',
      networkIcon: '',
      paymentMethodSuffix: '',
      cardLast4Display: ''
    },
    refundTransaction: {
      ID: '',
      merchantId: '',
      parentId: '',
      amount: '',
      transactionType: '',
      reason: '',
      status: '',
      date: '',
      time: '',
      timestamp: '',
      id: '',
      storeId: ''
    },
    refundTransactions: [],
    returnsTransactions: [],
    payoutStatus: '',
    payoutCreatedBy: '',
    payoutId: '',
    merchantId: '',
    hasAdditionalTax: false,
    additionalTax: '',
    additionalTaxAmount: '',
    serviceCharges: null,
    lineItems: [],
    profilePicture: '',
    createdBy: '',
    description: '',
    failureMessage: '',
    teamIcon: '',
    invoiceId: '',
    parentTransactionId: '',
    refundReason: '',
    customerId: '',
    customerAddress: '',
    customerPhone: '',
    customerEmail: '',
    email: '',
    website: '',
    tipPercentage: '',
    surchargePercentage: '',
    additionalTaxPercentage: '',
    payableAmount: '',
    isManualPayment: false,
    hasDiscount: false,
    discount: '',
    discountPercentage: '',
    attachments: null,
    receiptUrl: '',
    version: '',
    tnc: {
      tncId: 0,
      tnc: ''
    },
    taxes: [],
    errorCode: '',
    errorMessage: '',
    teamDetails: {
      address: '',
      phone: '',
      email: '',
      website: ''
    },
    disputeTransactions: null,
    customerSignature: {
      customerName: '',
      signatureFileKey: '',
      signaturePresignedUrl: '',
      formattedSignedAt: '',
      signedAt: '',
      isInvoiceSignatureEnabled: false,
      isInvoiceSigned: false
    },
    teamListings: {
      name: '',
      phone: '',
      email: '',
      address: '',
      iconPresignedUrl: '',
      yelp: '',
      facebook: '',
      website: '',
      otherOnlineReferrence: ''
    },
    comment: '',
    collectedBy: '',
    paymentSystem: null,
    isManualKeyed: false,
    transactionRelatedDetails: [],
    paymentMethodIcon: '',
    invoiceReferenceId: '',
    referenceNote: '',
    receiptMessage: '',
    totalAmount: '',
    isRefundExpired: false,
    chargedCardOnFile: false,
    totalInvoiceAmount: ''
  },
  refundData: {
    teamBankingBalance: '',
    futurePayouts: '',
    pendingPayouts: ''
  }
};

export const receiptSlice = createSlice({
  name: 'receipts',
  initialState,
  reducers: {
    resetReceiptState: () => initialState,
    updateRefundAmount: (state, { payload }: PayloadAction<string>) => {
      state.refundAmount = payload;
    },
    updateRefundReason: (state, { payload }: PayloadAction<string>) => {
      state.refundReason = payload;
    },
    initializeReceiptData: (state, { payload }: PayloadAction<ReceiptByIdResponse>) => {
      state.receiptData = payload;
    },
    updateConfrimRefundResponse: (state, { payload }: PayloadAction<PostConfirmRefundResponse>) => {
      state.refundData = payload;
    }
  }
});

export const {
  resetReceiptState,
  updateRefundAmount,
  initializeReceiptData,
  updateRefundReason,
  updateConfrimRefundResponse
} = receiptSlice.actions;

export const selectRefundAmount = (state: RootState) => state.rootReducer.receipts.refundAmount;
export const selectRefundReason = (state: RootState) => state.rootReducer.receipts.refundReason;
export const selectReceiptData = (state: RootState) => state.rootReducer.receipts.receiptData;
export const selectRefundData = (state: RootState) => state.rootReducer.receipts.refundData;
export default receiptSlice.reducer;
